<template>
    <div>
        <div class="sku-title">通话形式</div>
        <van-row>
            <van-col span="6"
                     v-if="hasType('CALL_NUMBER_1', 'CALL_1')">
                <div class="m-l-4 m-r-4 sku-item"
                     :class="{'sku-item-normal': pickedCall.indexOf('CALL_1')<0, 'sku-item-checked': pickedCall.indexOf('CALL_1')>=0}"
                     @click="toggleCall('CALL_1')">
                    录音通话
                </div>
            </van-col>
            <van-col span="6"
                     v-if="hasType('CALL_NUMBER_2', 'CALL_2')">
                <div class="m-l-4 m-r-4 sku-item"
                     :class="{'sku-item-normal': pickedCall.indexOf('CALL_2')<0, 'sku-item-checked': pickedCall.indexOf('CALL_2')>=0}"
                     @click="toggleCall('CALL_2')">
                    非录音通话
                </div>
            </van-col>
        </van-row>
        <div style="color: #a4afbc; font-size: 13px;">(优先使用录音通话时间)</div>

        <div class="sku-title" v-if="hasType('CALL_NUMBER_1', 'CALL_1') || hasType('CALL_NUMBER_2', 'CALL_2')">
            通话时长
        </div>
        <van-row v-if="hasType('CALL_NUMBER_1', 'CALL_1') || hasType('CALL_NUMBER_2', 'CALL_2')">
            <van-col v-for="(param, i) in paramList" :key="i" span="6">
                <div class="m-l-4 m-r-4 sku-item"
                     v-if="param.basicServiceCode == 'CALL_1'"
                     :class="{'sku-item-normal': pickedCallNum != param.defautValue, 'sku-item-checked': pickedCallNum == param.defautValue}"
                     @click="toggleCallNum(param.defautValue)">
                    {{param.defautValue}}{{unit}}
                </div>
            </van-col>
            <van-col :key="paramList.length" span="6">
                <div class="m-l-4 m-r-4 sku-item"
                     :class="{'sku-item-normal': pickedCallNum != 'custom', 'sku-item-checked': pickedCallNum == 'custom'}"
                     @click="toggleCallNum('custom')">
                    自定义
                </div>
            </van-col>
        </van-row>
        <div v-if="pickedCallNum == 'custom'"
             style="margin-bottom: 15px">
            <van-stepper v-model="pickedCallNumCustom"
                         integer
                         :step="10000"
                         @change="pickedCallNumInputChange"
                         input-width="100px"
                         :min="50000"
                         :max="10000000"></van-stepper>
        </div>
        <div v-if="pickedCallNumData && pickedCallNumData.length"
             style="font-size: 12px; color: #a4afbc; padding: 8px; background-color: #f0f0f0; border-radius: 5px">
            <span v-for="(m, i) in pickedCallNumData"
                  :key="i">
                {{m.consumptionTypeValue}}单价：{{m.unitPrice / m.unitNum / 100}}元/分钟
                <span v-if="i < pickedCallNumData.length - 1">；</span>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'va-call-sku',
        data() {
            return {
                pickedCallNum: '',
                pickedCallNumCustom: '',
                pickedCallNumData: [],
                pickedCall: []
            };
        },
        props: {
            paramList: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            unit: {
                default: function () {
                    return '';
                }
            }
        },
        computed: {},
        methods: {
            hasType(key, type) {
                let consumptionTypeKey = this.$route.query.consumptionTypeKey;
                if (consumptionTypeKey && consumptionTypeKey !== key) {
                    return false;
                }
                if (this.paramList && this.paramList.filter(m => m.basicServiceCode == type).length) {
                    return true;
                }
                return false;
            },
            toggleCall(option) {
                if (this.pickedCall.indexOf(option) >= 0) {
                    this.pickedCall.splice(this.pickedCall.indexOf(option), 1);
                } else {
                    this.pickedCall.push(option);
                }
                this.pickedCallNumChange();
            },
            toggleCallNum(value) {
                this.pickedCallNum = value;
                this.pickedCallNumChange();
            },
            // 数量 短信 云盘 客户数
            pickedCallNumChange() {
                // if (!(this.pickedCallNum && this.pickedCall.length)) {
                //     this.payPriceChange();
                //     return ;
                // };
                let L = _.cloneDeep(this.paramList);
                if (this.pickedCallNum == 'custom') {
                    this.pickedCallNumInputChange();
                    return;
                }
                // 循环L,根据数量判断
                let A = L.filter(item => (this.pickedCall.includes(item.basicServiceCode) && item.defautValue == this.pickedCallNum));

                this.pickedCallNumData = A;
                this.payPriceChange();
            },
            // 自定义数量
            pickedCallNumInputChange(val) {
                setTimeout(() => {
                    let num = val || this.pickedCallNumCustom;
                    // let num = this.pickedCallNumCustom;
                    let L = _.cloneDeep(this.paramList);
                    this.pickedCallNumData = L.filter((item) => {
                        return this.pickedCall.includes(item.basicServiceCode) && ((num >= item.minValue) && (num <= item.maxValue));
                    }).map(item => {
                        return {
                            ...item,
                            defautValue: num
                        };
                    });
                    this.payPriceChange();
                }, 200);
            },

            // 计算价格
            payPriceChange() {
                let price = 0;
                let A = this.pickedCallNumData;
                let skuName = '';
                if (A.length) {
                    let priceMap = A.map(item => {
                        let p = item.defautValue * item.unitPrice / item.unitNum;
                        // if (item.endDayNum > 0) {
                        //     p = (p / 365 * item.endDayNum);
                        // };
                        if (skuName) {
                            skuName += '；';
                        }
                        if (item.basicServiceCode == 'CALL_1') {
                            skuName += '录音通话：';
                        }
                        if (item.basicServiceCode == 'CALL_2') {
                            skuName += '非录音通话：';
                        }
                        skuName += item.defautValue + this.unit;
                        return p;
                    });
                    price = (Math.round(priceMap.reduce((prev, next) => prev + next)) / 100) || 0;
                } else {
                    price = 0;
                }
                this.$emit('callPriceChanged', this.pickedCallNumData, price, skuName);
            }
        }
    };
</script>

<style scoped>
    .sku-item {
        font-size: 12px;
        color: #07affa;
        text-align: center;
        border: #07affa 1px solid;
        border-radius: 4px;
        line-height: 27px;
        margin-bottom: 15px
    }

    .sku-item-normal {
        color: #28405e;
        border-color: #eee;
    }

    .sku--item-checked {
        color: #07affa;
        border-color: #07affa;
    }

    .sku-title {
        font-size: 13px;
        color: #596c83;
        background-color: white;
        margin-top: 20px;
        margin-bottom: 15px
    }
</style>
